module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_cerebral_aneurysm-312ed3326fdec87aa132807e149c5892.png";